export default "__VITE_ASSET__DtPrGEi$__"